"use client";

import type { ReactNode } from "react";
import { useTranslations } from "next-intl";
import { AkiliWordmark } from "@/components/onboarding/provider-icons";
import { ThemeToggle } from "@/components/theme-toggle";
import { V2_THEME_TOGGLE } from "./classes";

export interface V2NavProps {
  /**
   * The links and pills between the wordmark and the theme toggle. Each
   * screen builds its own from `V2_NAV_LINK` / `V2_NAV_PILL`.
   */
  actions?: ReactNode;
}

/**
 * The V2 top bar: the Akili wordmark (to the public microsite), the screen's
 * own actions, and the theme toggle. Rendered in `AuthShell`'s `nav` slot.
 */
export function V2Nav({ actions }: V2NavProps) {
  const t = useTranslations("AuthThemePage");
  return (
    <div className="flex flex-wrap items-center justify-between gap-4 px-5 py-4 sm:px-8 lg:px-13">
      <a href="https://akili.io" className="flex items-center gap-2.5" aria-label="Akili">
        <AkiliWordmark height={30} className="h-[30px] w-auto" />
      </a>
      <div className="flex items-center gap-2">
        {actions}
        <ThemeToggle label={t("nav.switchTheme")} className={V2_THEME_TOGGLE} />
      </div>
    </div>
  );
}
